import clsx from "clsx"
import styles from "@styles/HomeView.module.css"

export default function Date() {
  const now: globalThis.Date = new globalThis.Date()
  const days: string[] = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]
  const months: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]
  const dayName = days[now.getDay()]
  const day = now.getDate()
  const monthName = months[now.getMonth()]
  const year = now.getFullYear()
  const dateString = `${dayName}, ${day}. ${monthName} ${year}`

  return (
    <div>
      <span className={clsx("title1", styles.date)}>{dateString}</span>
    </div>
  )
}
